import { i18n } from 'bitmovin-player-ui/dist/js/framework/localization/i18n';
export function localizeKey(key) {
    return i18n.getLocalizer(key);
}
